import commonMixin from '../../mixins/_common';
import modalMixin from '../../mixins/_modal';
import flashMessageMixin from '../../mixins/_flash_messages';

/**
 * カテゴリ削除確認モーダル
 */
export default {
    name: 'modal-delete-category-confirm',
    template: '#modal_delete_category_confirm_template',
    data() {
        return {
            // カテゴリ名
            categoryName: null,
            // ページキー
            pageKey: null,
            // 商品データ配列
            items: null,
        };
    },
    mixins: [
        commonMixin,
        modalMixin,
        flashMessageMixin,
    ],
    computed: {
        // 商品データが有るか
        hasItems: function () {
            return (this.items !== null && this.items.length > 0);
        },
    },
    emits: ['delete-category'],
    methods: {
        // モーダルを開く
        openModal: async function (params) {
            this.categoryName = params.categoryName;
            this.pageKey = params.pageKey;
            this.items = await this.getRelatedItems();
            if(this.items === null) {
                // エラーが発生した場合、モーダルを開かず終了
                return;
            }
            // モーダルを開く
            this.open();
        },
        // カテゴリに紐づく商品を検索する
        getRelatedItems: async function () {
            let message = this.exception_error_message;
            let items = [];
            try {
                this.$_loading();
                const response = await axios.get('/item/get_related_items', {
                    params:{
                        _method: 'GET',
                        page_key: this.pageKey,
                    }});
                if (response.data.status === 'OK') {
                    items = response.data.items;
                    // エラーメッセージを空にする
                    message = '';
                } else {
                    message = response.data.message;
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            } finally {
                this.$_unloading();
            }
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                }, this.$parent);
                // エラーが発生した場合、nullを返す
                return null;
            }

            return items;
        },
        // カテゴリを削除する
        deleteCategory: async function () {
            let message = this.exception_error_message;
            try {
                this.$_loading();
                const response = await axios.delete('/item/delete_category', {
                    data: { _method: 'DELETE', page_key: this.pageKey },
                });

                if (response.data.status === 'OK') {
                    this.close();
                    // メッセージ表示
                    swal('削除しました');
                    // カテゴリ削除を通知
                    this.emitDeleteCategory();
                    message = '';
                }else {
                    message = response.data.message;
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            } finally {
                this.$_unloading();
                if (message) {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: message,
                    }, this.$parent);
                }
            }
        },
        // カテゴリ削除を通知する
        emitDeleteCategory: function () {
            this.$emit('delete-category', this.pageKey);
        },
    }
};
